import * as Preact from "preact"
import prettyms from "pretty-ms"

import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"

import "@frog/source/views/dev/screens/TestListScreen.view.less"

import tests from "@frog/source/tests/_.js" // TODO: lazy load this and all other imports to this file

// tests.sort((a, b) => {
//     a = a.slug?.[0]
//     b = b.slug?.[0]
//     if(a < b) return -1
//     if(a > b) return +1
//     return 0
// })

export default class TestListScreen {
    render() {
        return (
            <div class="TestListScreen" onClick={this.onClickOutOfModal}>
                <div class="Popup" onClick={this.onClickModal}>
                    <div class="Header">Tests</div>
                    {tests.map((test) => <TestOverview test={test}/>)}
                </div>
            </div>
        )
    }
    onClickModal(event) {
        event.preventDefault()
        event.stopPropagation()
    }
    onClickOutOfModal(event) {
        Navigation.state.devscreen = undefined
    }
}

class TestOverview {
    render() {
        return (
            <div class="TestOverview" onClick={this.onMouseOver}>
                <div class="Status" status={this.props.test.status}/>
                <div class="Slug">{this.props.test.slug}</div>
                <div class="Flex"/>
                <div class="Duration">{prettyms(this.props.test.duration || 0)}</div>
            </div>
        )
    }
    get onMouseOver() {
        return (event) => {
            Navigation.go("/dev/tests/" + this.props.test.slug)
        }
    }
}
